'use client';

/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import Button from '@egalite/ui/Buttons';
import ErrorList from '@egalite/ui/ErrorList';
import { InputField } from '@egalite/ui/Form';
import InputFieldGroup from '@egalite/ui/Form/InputFieldGroup';
import { useNotification } from '@egalite/ui/IncluiPCD/NotificationProvider';
import Loading from '@egalite/ui/Loading';
import Typography from '@egalite/ui/Typography';
import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';
import { FC, useEffect, useState } from 'react';
import authFetch from '../../lib/auth/authFetch';
import useForm from '../../lib/hooks/useForm';
import validationSchema, { initialValues } from '../../lib/validation/candidate/registerData';
import ButtonsPages from './legacy_blocks/ButtonsPages';
import FormPage from './legacy_blocks/CandidateFormPage';
import save from './save';

const Register: FC<{edit?: boolean, onSuccess?: () => void}> = ({ edit = false, onSuccess = null }) => {

	const notification = useNotification();
	const [loadingData, setLoadingData] = useState(true);
	const [candidateData, setCandidateData] = useState(initialValues);

	const router = useRouter();

	const [formController, getFieldProps, { loading, submitting, success, errors, data }] = useForm({
		initialValues: candidateData,
		validationSchema,
		mutation: (data) => save('/api/v1/candidate/registerData', data),
		onSuccess: onSuccess != null ? () => onSuccess() : () => { 
			router.push(`/candidato/form/personalData1`, {scroll: true}) 
		}
	});
	useEffect(() => {
		if(loadingData) {
			authFetch('/api/v2/candidate/profile', Cookies.get('token'))
				.then(res => res.json())
				.then(data => {
					if(data.success === true){
						const newValues = Object.keys(initialValues).reduce((acc, key) => {
							acc[key] = data.data[key] ?? initialValues[key];
							return acc;
						}, {});
						setCandidateData(newValues as typeof initialValues);
						setLoadingData(false)
					} else {
						notification.error('Erro ao carregar dados do candidato')
					}
				})
		}
	}, [formController, router, loadingData, notification]);


	if(loadingData) {
		return <Loading fullScreen={true}>carregando dados</Loading>;
	}

	return (
		<FormPage
			actualStep={1}
			formActualStep={1}
			formTotalSteps={1}
			progress={100}
			formTitle={'Dados cadastrais'}
			// previousForm="/"
			showStepsMenu={false}
			// showBackButton={false}
			modal={edit}
		>
			<form onSubmit={formController.handleSubmit}>
				<div className='mb-16 md:mb-24'>
					<InputField id="fullname" type="text" label="Nome completo" {...getFieldProps('fullname')} />
					<InputFieldGroup
						id="phone"
						type="text"
						label="Telefone"
						maskOptions={{
							mask: [
								{ mask: '(00) 0000-0000', lazy: false, placeholderChar: '_' },
								{ mask: '(00) 00000-0000', lazy: false, placeholderChar: '_' },
							],
						}}
						{...getFieldProps('phone')}
					/>

					<ErrorList errors={formController.errors} touched={formController.touched} />

					{errors != null &&
						errors.map((err, index) => (
							<Typography key={`err-${index}`} variant="body2" color="error.dark">
								{err}
							</Typography>
						))}
				</div>
				<div className='md:mt-24 mt-16'>
					{edit ?
						<Button type='submit' variant='primary' className='w-full'>Salvar</Button>
						:
						<ButtonsPages hideBack={true} />
					}
				</div>
			</form>
		</FormPage>
	);
}

export default Register;